import Firebase from "../../lib/Firebase";
import Firestore from "../../lib/Firestore";

export default {
  /*   categories() {
    return Firebase.firestore()
      .collection('display-categories')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  }, */

  all() {
    return (
      Firebase.firestore()
        .collection("users")
        // .where('role', '==', "agent")
        //.where('category', '==', category)
        .get()
        .then((docs) => {
          return Firestore.getCollectionData(docs);
        })
    );
  },
  dm() {
    return Firebase.firestore()
      .collection("users")
      .where("role", "==", "admin")
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  ledgers() {
    return Firebase.firestore()
      .collection("ledgre60List")
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  bu() {
    return Firebase.firestore()
      .collection("users")
      .where("role", "==", "bu")
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  fn() {
    return (
      Firebase.firestore()
        .collection("users")
        // .where('role', '==', "candidate")
        .get()
        .then((docs) => {
          return Firestore.getCollectionData(docs);
        })
    );
  },
  co() {
    return Firebase.firestore()
      .collection("users")
      .where("role", "==", "co")
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  op() {
    return Firebase.firestore()
      .collection("users")
      .where("role", "==", "op")
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },

  //myJSON : JSON.stringify(availableQuantities),

  manageUser(user) {
    console.log(user);
    const { name, email, premium, mobile, role, active = false } = user;

    const userObj = {
      name,
      email,
      premium,
      mobile,
      role,
      active,
    };
    console.log(userObj);
    const promise = user.docId
      ? Firebase.firestore()
          .collection("users")
          .doc(user.docId)
          .update(userObj)
      : Firebase.firestore()
          .collection("users")
          .add(userObj);

    return promise;
  },

  deleteUser(user) {
    return Firebase.firestore()
      .collection("users")
      .doc(user)
      .delete();
  },
};



// WEBPACK FOOTER //
// ./src/pages/users/service.js